export const GREEDY_LINE_BREAK_REGEX = /[\r\n|\n]+/g
export const SIMPLE_LINE_BREAK_REGEX = /\r\n|\n/
